import { Coins, Loader, Plus } from "lucide-react";

interface ChipProps {
  text: string;
  value: string;
  onClick: () => void;
  loading: boolean;
}

export const Chip = ({ text, value, onClick, loading }: ChipProps) => {
  const isZero = value === "0" || parseInt(value) === 0;

  return (
    <div className="flex flex-col items-center gap-1 mb-6">
      <span className="text-[10px] font-semibold uppercase tracking-widest text-gray-400">
        {text}
      </span>
      <div
        className="rounded-full pl-4 pr-1.5 py-1.5 flex items-center gap-3"
        style={{
          background: "white",
          border: "1.5px solid hsl(230 10% 78%)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div className="flex items-center gap-1.5">
          <Coins
            className="w-5 h-5"
            style={{ color: "hsl(40 75% 50%)" }}
          />
          <span
            className="font-bold text-lg tabular-nums leading-none"
            style={{ color: "hsl(230 10% 35%)" }}
          >
            {loading ? (
              <Loader size={16} color="#6569f1" />
            ) : (
              Number(value).toLocaleString()
            )}
          </span>
        </div>
        <button
          onClick={onClick}
          className="w-8 h-8 shrink-0 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center transition-colors shadow-md"
        >
          <Plus className="w-4 h-4 text-white" />
        </button>
      </div>
    </div>
  );
};
